import { BMCard } from "@traveloka/district-bloom";
import BMView from "../../../../components/View/BMView";
import { ProductType } from "../../../../types/product";
import MobileProductSection from "./MobileProductSection";

export type MobileHomeProductProps = {
  redirectProduct(productType: ProductType): void;
  disabled?: boolean;
};

export default function MobileHomeProduct(props: MobileHomeProductProps) {
  return (
    <BMCard layout="COMPACT" elevation="FLOAT">
      <BMView spacing="md">
        <MobileProductSection
          {...props}
          sections={[{ productType: "FLIGHT" }, { productType: "HOTEL" }]}
        />
      </BMView>
    </BMCard>
  );
}
